import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const Opportunity = () => {
  const { t } = useLang();
  const go = () =>
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="opportunity"
      data-testid="opportunity-section"
      className="scroll-mt-24 bg-[#1A1C19] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#B5A68B] mb-6">
            {t.opportunity.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#F4F3EF] max-w-3xl">
            {t.opportunity.title}
          </h2>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#B9B8B2] max-w-3xl">
            {t.opportunity.intro}
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {t.opportunity.columns.map((c, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div
                data-testid={`opportunity-column-${i}`}
                className="h-full bg-[#1A1C19] p-10 md:p-12"
              >
                <h3 className="font-serif text-2xl text-[#F4F3EF]">{c.title}</h3>
                <p className="mt-5 text-sm md:text-base leading-relaxed text-[#B9B8B2]">
                  {c.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14">
            <button
              data-testid="opportunity-cta"
              onClick={go}
              className="bg-[#F4F3EF] text-[#1A1C19] px-8 py-4 text-sm font-semibold tracking-wide hover:bg-[#B5A68B] transition-colors duration-300"
            >
              {t.opportunity.cta}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
